export default "__VITE_ASSET__PW3w4JbT__"